import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Grid,
  GridItem,
  Heading
} from "@chakra-ui/react";
import * as React from "react";
import SustainableFinanceRegulationsBox from "./SustainableFinanceRegulationsBox";

// TODO refactor to separate content from code

function SustainableFinanceRegulationsAccordionItem({title}) {
  const extendedJson = {
    "carbonPricing": {
      "content": [
        {
          "contentTitle": "UNITED KINGDOM",
          "flag": "ukFlag",
          "text": [
            {
              "header": "Carbon pricing summary",
              "points": [
                {
                  "point": "Is there a carbon pricing policy?",
                  "status": "Yes"
                }
              ]
            },
            {
              "header": "UK Emissions Trading Scheme",
              "points": [
                {
                  "point": "Year implemented",
                  "status": "2021"
                },
                {
                  "point": "Details:",
                  "status": "Following the UK’s departure from the EU ETS, the mechanics of the UK ETS are similar in nature to the EU ETS. However, the UK ETS has a stricter emission cap in line with its net zero strategy – with annual reductions of 4.2 metric tonnes – and a Cost Containment Mechanism (CCM) to mitigate price volatility, although this has not yet been used despite breaking thresholds. The ETS is scheduled for review in 2023 and 2028, and the use of carbon offsets is currently not permitted."
                },
                {
                  "point": "Share of jurisdiction’s GHG emissions:",
                  "status": "28%"
                },
                {
                  "point": "Carbon price:",
                  "status": "$98.4 per tonne of carbon dioxide equivalent. The minimum auction price stands at £22/tCO2e."
                },
                {
                  "link": "https://www.gov.uk/government/publications/participating-in-the-uk-ets/participating-in-the-uk-ets",
                  "point": "More information"
                },
                {
                  "link": "https://openknowledge.worldbank.org/handle/10986/37455",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "UK Carbon Price Support",
              "points": [
                {
                  "point": "Year implemented",
                  "status": "2012"
                },
                {
                  "point": "Details:",
                  "status": "This programme aims to reduce revenue uncertainty and improve the potential for investment in low-carbon generation for the UK electricity generation sector."
                },
                {
                  "point": "Share of jurisdiction’s GHG emissions:",
                  "status": "21%"
                },
                {
                  "point": "Carbon price:",
                  "status": "$25 per tonne of carbon dioxide equivalent. Minimum carbon price of £18/tCO2e until March 2024."
                },
                {
                  "link": "https://www.gov.uk/government/publications/uk-emissions-trading-scheme-and-carbon-price-support-apply-for-compensation#:~:text=The%20UK%20Emissions%20Trading%20Scheme%20(%20UK%20ETS%20)%20and%20Carbon%20Price,Energy%20Intensive%20Industries%20(EIIs).",
                  "point": "More information"
                }
              ]
            }
          ]
        },
        {
          "contentTitle": "EUROPEAN UNION",
          "flag": "euFlag",
          "text": [
            {
              "header": "Carbon pricing summary",
              "points": [
                {
                  "point": "Is there a carbon pricing policy?",
                  "status": "Yes"
                }
              ]
            },
            {
              "header": "EU Emissions Trading System",
              "points": [
                {
                  "point": "Year implemented",
                  "status": "2005"
                },
                {
                  "point": "Details:",
                  "status": "The EU’s ETS operates under a cap-and-trade principle. It imposes a cap of GHGs that companies can emit every year, called carbon credits. Industries with lower emissions have the opportunity to sell allowances to larger emitters. The cap is reduced by a linear reduction factor, recently increased by an additional 2% to 4.2%. Subject to legislative approval, the EU is set to further the ETS’ use in their decarbonisation agenda through the gradual reduction in aviations free allocation, the inclusion of the maritime sector in the ETS from 2023, and provisions for a separate trade system for fuel use in construction and transport."
                },
                {
                  "point": "Share of jurisdiction’s GHG emissions:",
                  "status": "41%"
                },
                {
                  "point": "Carbon price:",
                  "status": "~€92 per tonne of carbon dioxide equivalent. The latest information is available below."
                },
                {
                  "link": "https://ember-climate.org/data/data-tools/carbon-price-viewer/",
                  "point": "Carbon pricing information "
                },
                {
                  "link": "https://ec.europa.eu/clima/eu-action/eu-emissions-trading-system-eu-ets_en",
                  "point": "More information"
                },
                {
                  "point": "More details",
                  "status": "In December 2022, a provisional agreement on the Carbon Border Adjustment Mechanism was reached. Scheduled for October 2023, the CBAM counters risks associated with the offset of GHG emissions via cheaper imports of specific carbon intensive imports from external countries or shifting production. The mechanism will replace existing anti-leakage measures."
                },
                {
                  "link": "https://taxation-customs.ec.europa.eu/green-taxation-0/carbon-border-adjustment-mechanism_en",
                  "point": "More information"
                }
              ]
            }
          ]
        },
        {
          "contentTitle": "UNITED STATES",
          "flag": "usFlag",
          "text": [
            {
              "header": "Carbon pricing summary",
              "points": [
                {
                  "point": "Is there a carbon pricing policy?",
                  "status": "Yes"
                }
              ]
            },
            {
              "header": "California Carbon Cap-and-Trade Programme",
              "points": [
                {
                  "point": "Year implemented",
                  "status": "2013"
                },
                {
                  "point": "Details:",
                  "status": "Aims to help put California on the path to meet its goal of reducing GHG emissions to 1990 levels by 2020 and ultimately achieving an 80% reduction from 1990 levels by 2050. In the most recent review, which took effect on Jan 2021, it established a price ceiling and reductions in use of offset credits. A draft of the 2022 Scoping Plan, the quinquennial assessment on progress towards interim and 2045 net zero targets, was published in May 2022."
                },
                {
                  "point": "Share of jurisdiction’s GHG emissions:",
                  "status": "80%"
                },
                {
                  "point": "Carbon price:",
                  "status": "$28.3 per tonne of carbon dioxide equivalent. Auction floor price ≈$17/tCO2e continues to rise at an inflation-adjusted 5% per annum, with this quarter reflecting the highest carbon price to date."
                },
                {
                  "link": "https://www.c2es.org/content/california-cap-and-trade/",
                  "point": "More information"
                },
                {
                  "link": "https://ww2.arb.ca.gov/our-work/programs/ab-32-climate-change-scoping-plan/2022-scoping-plan-documents",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "Regional Greenhouse Gas Initiative",
              "points": [
                {
                  "point": "Year implemented",
                  "status": "2009"
                },
                {
                  "point": "Details:",
                  "status": "Market-based cap-and-trade system, comprising of 12 participating states along the Eastern US, established a regional cap on CO2 emissions from regulated power generating sources. Participating states include: Connecticut, Delaware, Maine, Maryland, Massachusetts, New Hampshire, New Jersey, New York, Pennsylvania, Rhode Island, Vermont, and Virginia. Pennsylvania, who joined the RGGI in 2022, is attributed a share of 45% of the 2022 cap. Allowances are primarily distributed via auctions. In 2021, a cost containment reserve (CCR) and emissions containment reserve (ECR) were established to support market stability efforts. CCR allowances are triggered at auction when prices would exceed a certain price – in 2021, $13/tCO2e – whereas ECR reserves are withheld should the price fall below a trigger price – in 2021, $6/tCO2e. A third Program Review, initiated in 2021, is expected to be concluded at the end of 2023."
                },
                {
                  "point": "Share of jurisdiction’s GHG emissions:",
                  "status": "11%"
                },
                {
                  "point": "Carbon price:",
                  "status": "$13.9 per tonne of carbon dioxide equivalent.The minimum reserve price that allowances can be sold for at auction was $2.38 per allowance in 2021, and increases at an inflation-adjusted 2.5% per annum. Auction results are available here."
                },
                {
                  "link": "https://www.rggi.org/",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "Washington Climate Commitment Act",
              "points": [
                {
                  "point": "Year implemented",
                  "status": "2023"
                },
                {
                  "point": "Details:",
                  "status": "Establishes a State cap-and-invest program including mechanisms for tradable emission allowances. The covers industrial facilities, certain fuel suppliers, in-state electricity generators, electricity importers, and natural gas distributors with annual greenhouse gas emissions above 25,000/MtCO2e. Allowances are available to purchase in quarterly auctions, the first of which took place in February 2023, for which a floor price of $22.20 was set. Available allowances will fall over time in line with State carbon reduction targets. Companies are required to submit ‘compliance instruments’ at the end of each four-year compliance period."
                },
                {
                  "point": "Share of jurisdiction’s GHG emissions:",
                  "status": "~75%"
                },
                {
                  "link": "https://ecology.wa.gov/Air-Climate/Climate-change/Climate-Commitment-Act",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "Massachusetts Limits on Emissions from Electricity Generators ",
              "points": [
                {
                  "point": "Year implemented",
                  "status": "2018"
                },
                {
                  "point": "Details:",
                  "status": "Covers the large electricity generators and compliments the RGGI model to ensure that binding decadal emissions targets from 2030 are met. A review of the regulation was concluded at the end of 2021. Since its inception, the cap has fallen from 8.7MtCO2 to 8MtCO2, and will continue to decrease annually by just below 0.2MtCO2. By 2050, the cap will stand at 1.8MtCO2."
                },
                {
                  "point": "Share of jurisdiction’s GHG emissions:",
                  "status": "8%"
                },
                {
                  "point": "Carbon price:",
                  "status": "$0.50 per tonne of carbon dioxide equivalent"
                },
                {
                  "link": "https://www.mass.gov/guides/electricity-generator-emissions-limits-310-cmr-774",
                  "point": "More information"
                },
                {
                  "link": "https://icapcarbonaction.com/system/files/document/220408_icap_report_rz_web.pdf",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "Oregon Emissions Trading system ",
              "points": [
                {
                  "point": "Year implemented",
                  "status": "2022"
                },
                {
                  "point": "Details:",
                  "status": " Mandatory declining limits of greenhouse gas emissions for liquid fuel and natural gas suppliers and distributors, established under the Climate Protection Program. The program covers two types of fuel suppliers: local suppliers, and suppliers of liquid fuels and propane. For the latter, decreasing thresholds from 200,000/tCO2e in 2022 to 25,000/tCO2e in 2027 onwards seek to ensure the allowance cap is reduced from 28.2MtCO2e to 3MtCO2e by 2050."
                },
                {
                  "point": "Share of jurisdiction’s GHG emissions:",
                  "status": "43%"
                },
                {
                  "link": "https://www.oregon.gov/deq/Regulations/rulemaking/RuleDocuments/ghgcr2021overviewFS.pdf",
                  "point": "More information"
                },
                {
                  "link": "https://icapcarbonaction.com/system/files/document/220408_icap_report_rz_web.pdf",
                  "point": "More information"
                }
              ]
            }
          ]
        }
      ],
      "sectionTitle": "Carbon pricing"
    },
    "commitment": {
      "content": [
        {
          "contentTitle": "UNITED KINGDOM",
          "flag": "ukFlag",
          "text": [
            {
              "header": "Net zero commitment summary",
              "points": [
                {
                  "point": "Net zero target:",
                  "status": "2050"
                },
                {
                  "point": "Status:",
                  "status": "Mandated in law"
                },
                {
                  "point": "Details:",
                  "status": "The legal framework for the UK’s net zero commitment is built upon the Climate Change Act 2008, initially committing UK to an 80% reduction in carbon emissions by 2050, relative to 1990 levels. In 2019, the UK became the first major economy to legislate to reach net zero by 2050. The UK’s sixth carbon budget will incorporate the UK’s share of international aviation and shipping emissions, and pledges a 68% emission reduction by 2030 on 1990 levels. In September 2022, updates to the UK’s nationally determined contribution included additional details on the delivery of the 2030 targets, as well as its alignment with the principles of the Paris agreement."
                },
                {
                  "link": "https://assets.publishing.service.gov.uk/government/uploads/system/uploads/attachment_data/file/1033990/net-zero-strategy-beis.pdf",
                  "point": "More information"
                }
              ]
            }
          ]
        },
        {
          "contentTitle": "EUROPEAN UNION",
          "flag": "euFlag",
          "text": [
            {
              "header": "Net zero commitment summary",
              "points": [
                {
                  "point": "Net zero target:",
                  "status": "2050"
                },
                {
                  "point": "Status:",
                  "status": "Mandated in law"
                },
                {
                  "point": "Details:",
                  "status": "The EU’s net zero commitment is in line with the European Green Deal and its pledge to global climate action under the Paris agreement. EU member states are required to develop national long-term strategies on how they plan to achieve the green house gas emission reductions needed to meet their commitments under the Paris agreement and EU objectives. In July 2021, the European Climate Law enshrined in law the emission commitments set out in the European Green Deal: neutrality by 2050 and a 55% reduction by 2030 (to 1990 levels)."
                },
                {
                  "link": "https://ec.europa.eu/clima/policies/strategies/2050_en",
                  "point": "More information"
                },
                {
                  "link": "https://alternative-fuels-observatory.ec.europa.eu/policymakers-and-public-authorities/european-policies-and-legislation",
                  "point": "More information"
                }
              ]
            }
          ]
        },
        {
          "contentTitle": "UNITED STATES",
          "flag": "usFlag",
          "text": [
            {
              "header": "Net zero commitment summary",
              "points": [
                {
                  "point": "Net zero target:",
                  "status": "2050"
                },
                {
                  "point": "Status:",
                  "status": "Mandated in law"
                },
                {
                  "point": "Details:",
                  "status": "The executive order, signed December 2021, commits to leading the nation to net zero by 2050. It includes a commitment to 100% carbon-free electricity on a net annual basis by 2030, including 50% constant carbon-free electricity production."
                },
                {
                  "link": "https://www.whitehouse.gov/briefing-room/presidential-actions/2021/12/08/executive-order-on-catalyzing-clean-energy-industries-and-jobs-through-federal-sustainability/",
                  "point": "More information"
                }
              ]
            }
          ]
        }
      ],
      "sectionTitle": "Net zero commitment"
    },
    "disclosures": {
      "content": [
        {
          "contentTitle": "UNITED KINGDOM",
          "flag": "ukFlag",
          "text": [
            {
              "header": "Disclosure summary",
              "points": [
                {
                  "point": "Are there mandatory rules on sustainability-related disclosures (aside from TCFD)?",
                  "status": "Under consideration"
                }
              ]
            },
            {
              "header": "Sustainable disclosure requirements and investment labels",
              "points": [
                {
                  "point": "Relevant authority",
                  "status": "HM Government, Financial Conduct Authority"
                },
                {
                  "point": "Details:",
                  "status": "The SDR intends builds on the FCA’s existing TCFD-based disclosure requirements by bring existing international and domestic frameworks, including the UK taxonomy, under a consolidated framework. In October 2022, the FCA issued a consultation paper (CP22/20) proposing new regulations, including requirements for regulated firms to assist retail investors with navigating sustainability-linked products. Measures set out in CP22/20 includes consumer-facing disclosures, as well as detailed product- and entity-level disclosures, and an ‘anti-greenwashing’ rule to restrict the misleading use of sustainable investment product labels. Distributors are required to ensure labels and disclosures are easily accessible and clear. The consultation builds on earlier discussion papers, like DP21/4, and has been drafted alongside expert-led initiatives aligned with the UK roadmap. The proposals have also sought to adhere with existing international frameworks (particularly the EU SFDR, and proposals from the US Securities and Exchange Commission) and recommendations from trade bodies (IOSCO, FSB). The FCA intends to publish finalised guidance by July 2023.The FCA has clarified that the proposals seek to build on TCFD-aligned disclosure recommendations with more detailed disclosure requirements, whilst the ISSB standards will be integrated into their disclosure frameworks for listed companies upon their finalisation."
                },
                {
                  "link": "https://assets.publishing.service.gov.uk/government/uploads/system/uploads/attachment_data/file/1031805/CCS0821102722-006_Green_Finance_Paper_2021_v6_Web_Accessible.pdf",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "TPT",
              "points": [
                {
                  "point": "Details:",
                  "status": "The Transition Plan Taskforce (TPT) is a private-public workgroup launched with by the Treasury in 2022 which seeks to build on the global baseline set out by the ISSB. In November 2022, the taskforce published its TPT Disclosure Framework, which proposes a sector-neutral framework for the development of climate transition plans, and Implementation Guidance on transition plan disclosures. Consultation on the proposals closed in February 2023 and final guidance is set to be published in Summer/Autumn. The disclosure framework is set to inform future FCA listing rules and disclosure requirements, referencing the TCFD and ISSB standards."
                }
              ]
            }
          ]
        },
        {
          "contentTitle": "EUROPEAN UNION",
          "flag": "euFlag",
          "text": [
            {
              "header": "Disclosure summary",
              "points": [
                {
                  "point": "Are there mandatory rules on sustainability-related disclosures (aside from TCFD)?",
                  "status": "Yes"
                }
              ]
            },
            {
              "header": "EU Taxonomy Climate Delegated Act",
              "points": [
                {
                  "point": "Relevant authority",
                  "status": "European Commission"
                },
                {
                  "point": "Enforced:",
                  "status": "January 2022"
                },
                {
                  "point": "Details:",
                  "status": "The delegated act specifies disclosure obligations for financial institutions under the EU Taxonomy Regulation. In October 2022, disclosure requirements were extended to account for taxonomy-aligned nuclear and gas-sector investments."
                },
                {
                  "link": "https://ec.europa.eu/info/business-economy-euro/banking-and-finance/sustainable-finance/eu-taxonomy-sustainable-activities_en",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "Sustainable Finance Disclosure Regulation",
              "points": [
                {
                  "point": "Relevant authority",
                  "status": "ECB and European Banking Authority"
                },
                {
                  "point": "Details:",
                  "status": "The SFDR lays down harmonised rules for financial market participants and financial advisers on transparency. It includes the integration of sustainability risks, consideration of adverse sustainability impacts in firms’ processes and the provision of sustainability-related information with respect to financial products. The necessary disclosures include:All financial market participants must publish information about how they are integrating sustainability risks into their investment decision making process.Financial market participants have to publish statements about the principal adverse impacts of investment decisions on sustainability factors and due diligence policies with respect to those impacts, taking into account the size, nature and scale of their activities and types of financial products they produce. They must disclose the reasons for not considering any adverse effects of investment decisions on sustainability factors and, where relevant, information on whether and when they intend to consider such adverse impacts"
                },
                {
                  "link": "https://ec.europa.eu/info/business-economy-euro/banking-and-finance/sustainable-finance/sustainability-related-disclosure-financial-services-sector_en",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "Non-financial Reporting Directive",
              "points": [
                {
                  "point": "Relevant authority",
                  "status": "European Commission, ECB and European Banking Authority"
                },
                {
                  "point": "Enforced:",
                  "status": "2014"
                },
                {
                  "point": "Details:",
                  "status": "Companies are required to prepare a non-financial statement containing information relating to environmental, social and employee-related matters, respect for human rights, anti-corruption and bribery matters. The Technical Expert Group (TEG) published a report in January 2019 defining the relationship between the NFRD and Task Force on Climate-related Financial Disclosures and outlines how companies could integrate the two disclosure requirements. The NFRD remains in force until the application of the Corporate Sustainability Reporting Directive is realised in 2025."
                },
                {
                  "link": "https://ec.europa.eu/info/publications/non-financial-reporting-guidelines_en",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "Corporate Sustainability Reporting Directive",
              "points": [
                {
                  "point": "Relevant authority",
                  "status": " European Commission, European Financial Reporting Advisory Group"
                },
                {
                  "point": "Date implemented:",
                  "status": "2023"
                },
                {
                  "point": "Details:",
                  "status": "The proposed directive extends the scope of the NFRD through more detailed reporting requirements and auditing rules, applying to large and listed companies as well as non-EU companies turning over more than €150m. The CSRD entered into force in January 2023, with eligible companies due to report on FY2024 in their 2025 reports. EFRAG was requested by the European Commission to develop the detailed ESG-related disclosure requirements for companies under the CSRD. The first draft standards, the European Sustainability Reporting Standards (ESRS), were published in November 2022 and are set to be finalised as delegated acts in June 2023."
                },
                {
                  "link": "https://ec.europa.eu/info/business-economy-euro/company-reporting-and-auditing/company-reporting/corporate-sustainability-reporting_en",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "Guidelines on funds’ names using ESG or sustainability-related terms",
              "points": [
                {
                  "point": "Relevant authority",
                  "status": "European Securities and Markets Authority"
                },
                {
                  "point": "Details:",
                  "status": "ESMA launched a consultation into guidelines for ESG-related investment fund labels in November 2022. The draft proposals include an 80% quantitative threshold for the use of ESG-related language, as well as an additional 50% threshold for sustainability terms, and potential exclusion criteria."
                },
                {
                  "link": "https://www.esma.europa.eu/press-news/esma-news/esma-launches-consultation-guidelines-use-esg-or-sustainability-related-terms#:~:text=In%20order%20not%20to%20mislead,fund's%20investment%20objectives%20and%20policy",
                  "point": "More information"
                }
              ]
            }
          ]
        },
        {
          "contentTitle": "UNITED STATES",
          "flag": "usFlag",
          "text": [
            {
              "header": "Disclosure summary",
              "points": [
                {
                  "point": "Are there mandatory rules on sustainability-related disclosures (aside from TCFD)?",
                  "status": "Under consideration"
                }
              ]
            },
            {
              "header": "Investment company names",
              "points": [
                {
                  "point": "Relevant authority",
                  "status": "Securities and Exchange Commission"
                },
                {
                  "point": "Details:",
                  "status": "Proposed amendments to the naming rules would require that funds labelled as ESG adhere to the 80% investment policy requirement and would define certain misappropriations in a bid to prevent greenwashing."
                },
                {
                  "link": "https://www.sec.gov/files/ic-34593-fact-sheet.pdf",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "ESG Disclosures for Investment Advisers and Investment Companies",
              "points": [
                {
                  "point": "Relevant authority",
                  "status": "SEC"
                },
                {
                  "point": "Details:",
                  "status": "Disclosure requirements are conditional on the degree of ESG focus, with many funds required to publish their strategies in annual publications. According to the proposal, ESG-focused funds would be required to publish tabular disclosures regarding ESG strategy, integration and active engagement."
                },
                {
                  "link": "https://www.sec.gov/files/ia-6034-fact-sheet.pdf",
                  "point": "More information"
                }
              ]
            }
          ]
        }
      ],
      "sectionTitle": "Other sustainability-related disclosures"
    },
    "financialPolicy": {
      "content": [
        {
          "contentTitle": "UNITED KINGDOM",
          "flag": "ukFlag",
          "text": [
            {
              "header": "Financial policy summary",
              "points": [
                {
                  "point": "Is there a nature- or biodiversity-related financial policy?",
                  "status": "None"
                },
                {
                  "point": "Details:",
                  "status": "Following the publication of the Dasgupta Report in February 2021, the UK government pledged an additional £3m to the impending Taskforce for Nature-related Financial Disclosures framework in 2023. Alongside Ecuador, Gabon and the Maldives, the UK Government cosigned and developed the 10 point plan for financing biodiversity, as a mechanism for galvanising political support to bridge finance gaps through international public finance. 16 countries have signed up to the plan, including France, Netherlands, Germany, Canada and the EU."
                }
              ]
            },
            {
              "header": "TNFD forum membership",
              "points": [
                {
                  "point": "Details",
                  "status": "The Taskforce on Nature-related Financial Disclosures aims to develop a risk management and disclosure framework for organisations to report on evolving nature-related risks. The TNFD forum members consist of institutional supporters who support the TNFD mission."
                },
                {
                  "point": "Member of the TNFD forum?",
                  "status": "Yes"
                },
                {
                  "link": "Bank of England, UK Government (Department for Environment, Food and Rural Affairs), Government of Scotland, Guernsey Financial Services Commission",
                  "point": "Relevant authorities:"
                }
              ]
            }
          ]
        },
        {
          "contentTitle": "EUROPEAN UNION",
          "flag": "euFlag",
          "text": [
            {
              "header": "Financial policy summary",
              "points": [
                {
                  "point": "Is there a nature- or biodiversity-related financial policy?",
                  "status": "Yes"
                },
                {
                  "point": "Details:",
                  "status": "Environmental risks such as biodiversity loss feature in the ECB supervisory expectations for banks, as set out in the 2020 guide on climate-related and environmental risks. Institutions are expected to evaluate these risks alongside climate-related risks more broadly. As part of the 2022 thematic review, the ECB conducted a review of risk management integration and practices. The bank reiterated that compliance with the supervisory guidance is expected for all banks by the end of 2024 at the latest."
                },
                {
                  "link": "https://www.ecb.europa.eu/press/key/date/2022/html/ecb.sp220929_2~d6497c36da.en.html",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "Natural Capital Financing Facility",
              "points": [
                {
                  "point": "Relevant authority",
                  "status": "European Commission and European Investment Bank"
                },
                {
                  "point": "Year implemented:",
                  "status": "2015"
                },
                {
                  "point": "Details:",
                  "status": "The NCFF supports projects delivering on biodiversity and climate adaptation through tailored loans and investments, backed by an EU guarantee. This includes ecosystem-based solutions to challenges related to land, soil, forestry, agriculture, water and waste."
                },
                {
                  "link": "https://www.eib.org/en/products/blending/ncff/index.htm",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "TNFD forum membership",
              "points": [
                {
                  "point": "Details:",
                  "status": "The Taskforce on Nature-related Financial Disclosures aims to develop a risk management and disclosure framework for organisations to report on evolving nature-related risks. The TNFD forum members consist of institutional supporters who support the TNFD mission."
                },
                {
                  "point": "Member of the TNFD forum?",
                  "status": "Yes"
                },
                {
                  "point": "Relevant authority",
                  "status": "ECB, European Investment Bank and European Bank for Reconstruction and Development"
                }
              ]
            }
          ]
        },
        {
          "contentTitle": "UNITED STATES",
          "flag": "usFlag",
          "text": [
            {
              "header": "Financial policy summary",
              "points": [
                {
                  "point": "Is there a nature- or biodiversity-related financial policy?",
                  "status": "None"
                }
              ]
            },
            {
              "header": "TNFD forum membership",
              "points": [
                {
                  "point": "Details:",
                  "status": "The Taskforce on Nature-related Financial Disclosures aims to develop a risk management and disclosure framework for organisations to report on evolving nature-related risks. The TNFD forum members consist of institutional supporters who support the TNFD mission."
                },
                {
                  "point": "Member of the TNFD forum?",
                  "status": "No"
                }
              ]
            }
          ]
        }
      ],
      "sectionTitle": "Nature-related financial policy"
    },
    "framework": {
      "content": [
        {
          "contentTitle": "UNITED KINGDOM",
          "flag": "ukFlag",
          "text": [
            {
              "header": "Framework summary",
              "points": [
                {
                  "point": "Is there a local green bond framework?",
                  "status": "Yes"
                }
              ]
            },
            {
              "header": "UK Government Green Financing Framework",
              "points": [
                {
                  "point": "Relevant authority",
                  "status": "HM Treasury, UK Debt Management Office"
                },
                {
                  "point": "Type of bonds:",
                  "status": "Green gilts"
                },
                {
                  "point": "Most recent edition:",
                  "status": "2021"
                },
                {
                  "point": "Details:",
                  "status": "Developed according to the ICMA Green Bond Principles, with intentions to align with the UK’s developing classification of environmentally sustainable economic activities, under the UK taxonomy. Details the types of expenditures that will be financed to help meet the government’s green objectives."
                },
                {
                  "link": "https://assets.publishing.service.gov.uk/government/uploads/system/uploads/attachment_data/file/1002578/20210630_UK_Government_Green_Financing_Framework.pdf",
                  "point": "More information"
                },
                {
                  "point": "History:",
                  "status": "Following consultation on ESG integration with capital markets, the FCA published a feedback statement FS22/4 in June 2022. Subject to government policy and taxonomy developments, a sustainability-linked bond standard may be reconsidered. Issuers are encouraged to follow existing advertising obligations and consider industry standards, such as from the ICMA."
                }
              ]
            }
          ]
        },
        {
          "contentTitle": "EUROPEAN UNION",
          "flag": "euFlag",
          "text": [
            {
              "header": "Framework summary",
              "points": [
                {
                  "point": "Is there a local green bond framework?",
                  "status": "Yes"
                }
              ]
            },
            {
              "header": "NextGenerationEU Green Bond framework",
              "points": [
                {
                  "point": "Relevant authority",
                  "status": "European Commission"
                },
                {
                  "point": "Type of bonds:",
                  "status": "Green bonds"
                },
                {
                  "point": "Most recent edition:",
                  "status": "2022"
                },
                {
                  "point": "Details:",
                  "status": "Framework is aligned with the ICMA’s Green Bond Principles and is coherent with wider ESG strategy"
                },
                {
                  "link": "https://ec.europa.eu/info/strategy/eu-budget/eu-borrower-investor-relations/nextgenerationeu-green-bonds_en",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "SURE Social Bond Framework",
              "points": [
                {
                  "point": "Relevant authority",
                  "status": "European Commission"
                },
                {
                  "point": "Type of bonds:",
                  "status": "Social bonds"
                },
                {
                  "point": "Most recent edition:",
                  "status": "2020"
                },
                {
                  "point": "Details:",
                  "status": "Compliant with the Social Bond Principles of the ICMA. The Commission issued €91.8bn across 8 lines to finance short-term employment schemes."
                },
                {
                  "link": "https://ec.europa.eu/info/strategy/eu-budget/eu-borrower-investor-relations/sure-social-bonds_en",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "EU Green Bond Standard",
              "points": [
                {
                  "point": "Relevant authority",
                  "status": "ECB and European Banking Authority"
                },
                {
                  "point": "Type of bonds:",
                  "status": "Green bonds"
                },
                {
                  "point": "Most recent edition:",
                  "status": "2020"
                },
                {
                  "point": "Details:",
                  "status": "Voluntary standard to help scale up and raise the environmental ambitions of the green bond market under 4 key requirements: taxonomy-alignment, transparency, external review and ESMA supervision."
                },
                {
                  "link": "https://ec.europa.eu/info/business-economy-euro/banking-and-finance/sustainable-finance/european-green-bond-standard_en#proposal",
                  "point": "More information"
                }
              ]
            }
          ]
        },
        {
          "contentTitle": "UNITED STATES",
          "flag": "usFlag",
          "text": [
            {
              "header": "Framework summary",
              "points": [
                {
                  "point": "Is there a local green bond framework?",
                  "status": "None"
                }
              ]
            }
          ]
        }
      ],
      "sectionTitle": "Green bond framework"
    },
    "guidelines": {
      "content": [
        {
          "contentTitle": "UNITED KINGDOM",
          "flag": "ukFlag",
          "text": [
            {
              "header": "Regulatory guidelines",
              "points": [
                {
                  "point": "Are there any regulatory guidelines on managing financial risks from climate change?",
                  "status": " Yes"
                }
              ]
            },
            {
              "header": "Enhancing Banks’ and Insurers’ Approaches to Managing the Financial Risks from Climate Change",
              "points": [
                {
                  "point": "Relevant authority:",
                  "status": "Prudential Regulatory Authority"
                },
                {
                  "point": "Enforced: ",
                  "status": "April 2019"
                },
                {
                  "point": "Details:",
                  "status": "Sets out expectations of the PRA regarding the incorporation of climate risk into risk management practices, strategy and long-term plans. Provides information about conducting regular stress testing and scenario analysis."
                },
                {
                  "link": "https://www.bankofengland.co.uk/-/media/boe/files/prudential-regulation/supervisory-statement/2019/ss319.pdf?la=en&hash=7BA9824BAC5FB313F42C00889D4E3A6104881C44",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "Managing Climate-related Financial Risk",
              "points": [
                {
                  "point": "Relevant authority",
                  "status": "Bank of England"
                },
                {
                  "point": "Enforced",
                  "status": "July 2020"
                },
                {
                  "point": "Details:",
                  "status": "This gathers thematic feedback from the PRA’s review of firms’ supervisory statement plans."
                },
                {
                  "link": "https://www.bankofengland.co.uk/-/media/boe/files/prudential-regulation/letter/2020/managing-the-financial-risks-from-climate-change.pdf?la=en&hash=A6B4DD1BE45B2762900F54B2F5BF2F99FA448424",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "Climate-related Financial Disclosure",
              "points": [
                {
                  "point": "Relevant authority",
                  "status": "Bank of England"
                },
                {
                  "point": "Enforced",
                  "status": "June 2020"
                },
                {
                  "point": "Details:",
                  "status": "This sets out the Bank’s approach to managing climate-related risks across its entire operations. The Bank has also issued a range of expectations and undertaken a variety of exercises that are designed to ensure that financial firms manage these risk effectively."
                },
                {
                  "link": "https://www.bankofengland.co.uk/-/media/boe/files/annual-report/2020/climate-related-financial-disclosure-report-2019-20.pdf?la=en&hash=5DA959C54540287A2E90C823807E089055E6721B",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "A Framework for Assessing Financing Impacts of Physical Climate Change",
              "points": [
                {
                  "point": "Relevant authority",
                  "status": "Bank of England"
                },
                {
                  "point": "Enforced",
                  "status": "June 2020"
                },
                {
                  "link": "https://www.bankofengland.co.uk/prudential-regulation/publication/2019/a-framework-for-assessing-financial-impacts-of-physical-climate-change",
                  "point": "More information"
                }
              ]
            }
          ]
        },
        {
          "contentTitle": "EUROPEAN UNION",
          "flag": "euFlag",
          "text": [
            {
              "header": "Regulatory guidelines",
              "points": [
                {
                  "point": "Are there any regulatory guidelines on managing financial risks from climate change?",
                  "status": " Yes"
                }
              ]
            },
            {
              "header": "Guide on Climate-related and Environmental Risks",
              "points": [
                {
                  "point": "Relevant authority:",
                  "status": "ECB"
                },
                {
                  "point": "Enforced:",
                  "status": "November 2020"
                },
                {
                  "point": "Details:",
                  "status": "The guidelines describe how the ECB expects institutions to consider climate-related and environmental risks when formulating and implementing strategy, governance and risk management frameworks. The ECB conducted an assessment of bank approaches and integration of C&E risks in the 2022 thematic review, announcing staggered deadlines for compliance with the expectations by the end of 2024. The results of the review also contributed to publications on best practice for risk management"
                },
                {
                  "link": "https://www.bankingsupervision.europa.eu/ecb/pub/pdf/ssm.202011finalguideonclimate-relatedandenvironmentalrisks~58213f6564.en.pdf",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "Report on Environmental, Social and Governance Risk Management and Supervision",
              "points": [
                {
                  "point": "Relevant authority",
                  "status": "European Banking Authority"
                },
                {
                  "point": "Details:",
                  "status": "This regulation defines two new types of climate benchmark: the EU climate transition benchmark, labelling portfolios on a ‘decarbonisation trajectory’ towards the Paris agreement objectives, and the EU Paris-aligned benchmark, labelling those already aligned with the Paris agreement objectives insofar as the carbon emission savings of each underlying asset exceed its carbon footprint."
                },
                {
                  "link": "https://commission.europa.eu/select-language?destination=/node/9",
                  "point": "More information"
                }
              ]
            }
          ]
        },
        {
          "contentTitle": "UNITED STATES",
          "flag": "usFlag",
          "text": [
            {
              "header": "Regulatory guidelines",
              "points": [
                {
                  "point": "Are there any regulatory guidelines on managing financial risks from climate change?",
                  "status": "Yes"
                }
              ]
            },
            {
              "header": "Principles for Climate-Related Financial Risk Management for Large Banks",
              "points": [
                {
                  "point": "Relevant authority",
                  "status": "Office of the Comptroller of the Currency"
                },
                {
                  "point": "Details:",
                  "status": "In December 2021, the OCC requested industry feedback on its draft principles designed to support the identification and management of climate-related financial risks for large banks with more than $100 billion in consolidated assets. As of March 2022, staff are reviewing feedback and intend to work with the Federal Reserve and the Federal Deposit Insurance Corporation on an interagency basis to finalize the principles and develop more detailed guidance."
                },
                {
                  "link": "https://www.occ.gov/news-issuances/bulletins/2021/bulletin-2021-62.html",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "New York Stock Exchange ESG Guidance",
              "points": [
                {
                  "point": "Relevant authority",
                  "status": "New York Stock Exchange"
                },
                {
                  "point": "Enforced:",
                  "status": "May 2021"
                },
                {
                  "point": "Details:",
                  "status": "The guide assists companies with ESG disclosures by highlighting key elements of good quality reporting and drawing attention to useful resources, including those provided by the New York Stock Exchange."
                },
                {
                  "link": "https://www.nyse.com/esg-guidance",
                  "point": "More information"
                }
              ]
            }
          ]
        }
      ],
      "sectionTitle": "Climate risk management guidelines"
    },
    "reporting": {
      "content": [
        {
          "contentTitle": "UNITED KINGDOM",
          "flag": "ukFlag",
          "text": [
            {
              "header": "Reporting status",
              "points": [
                {
                  "point": "Is reporting under, or aligned with, the Task Force for Climate-related Financial Disclosures framework mandatory or endorsed by government?",
                  "status": " Yes"
                },
                {
                  "point": "Relevant authority:",
                  "status": "UK Government"
                },
                {
                  "point": "Details:",
                  "status": "Mandatory for the largest UK companies and financial institutions from April 2022. Required for all UK firms by 2025, but with a significant portion of requirements in place by 2023."
                },
                {
                  "link": "https://www.legislation.gov.uk/uksi/2022/46/contents/made",
                  "point": "More information"
                },
                {
                  "link": "https://assets.publishing.service.gov.uk/government/uploads/system/uploads/attachment_data/file/1056085/mandatory-climate-related-financial-disclosures-publicly-quoted-private-cos-llps.pdf",
                  "point": "More information"
                },
                {
                  "point": "Relevant authority:",
                  "status": "Financial Conduct Authority"
                },
                {
                  "link": "https://www.fca.org.uk/publications/policy-statements/ps-21-23-enhancing-climate-related-disclosures-standard-listed-companies",
                  "point": "More information"
                },
                {
                  "link": "https://www.fca.org.uk/publications/policy-statements/ps-21-24-climate-related-disclosures-asset-managers-life-insurers-regulated-pensions",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "TCFD supporters",
              "points": [
                {
                  "point": "Details",
                  "status": "Supporters are organisations that publicly and voluntarily endorse TCFD implementation."
                },
                {
                  "point": "Total number of supporters:",
                  "status": "497"
                },
                {
                  "point": "Number of financial sector supporters:",
                  "status": "280"
                },
                {
                  "link": "https://www.fsb-tcfd.org/supporters/",
                  "point": "More information"
                }
              ]
            }
          ]
        },
        {
          "contentTitle": "EUROPEAN UNION",
          "flag": "euFlag",
          "text": [
            {
              "header": "Reporting status",
              "points": [
                {
                  "point": "Is reporting under, or aligned with, the Task Force for Climate-related Financial Disclosures framework mandatory or endorsed by government?",
                  "status": " Yes"
                },
                {
                  "point": "Relevant authority:",
                  "status": "European Parliament, ECB and European Banking Authority"
                },
                {
                  "point": "Details:",
                  "status": "Coming into effect in March 2021, disclosure regulation (EU 2019/2088) established new guidelines for ESG-related disclosures within the financial services sector."
                },
                {
                  "link": "https://ec.europa.eu/info/business-economy-euro/banking-and-finance/sustainable-finance/sustainability-related-disclosure-financial-services-sector_en",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "TCFD supporters",
              "points": [
                {
                  "point": "Details",
                  "status": "Supporters are organisations that publicly and voluntarily endorse TCFD implementation."
                },
                {
                  "point": "Total number of supporters:",
                  "status": "624"
                },
                {
                  "point": "Number of financial sector supporters:",
                  "status": "301"
                },
                {
                  "link": "https://www.fsb-tcfd.org/supporters/",
                  "point": "More information"
                }
              ]
            }
          ]
        },
        {
          "contentTitle": "UNITED STATES",
          "flag": "usFlag",
          "text": [
            {
              "header": "Reporting status",
              "points": [
                {
                  "point": "Is reporting under, or aligned with, the Task Force for Climate-related Financial Disclosures framework mandatory or endorsed by government?",
                  "status": " Yes"
                },
                {
                  "point": "Relevant authority:",
                  "status": "Securities and Exchange Commission"
                },
                {
                  "point": "Details:",
                  "status": " Announced March 2022, with mandatory requirements phased in 2023-2026"
                },
                {
                  "link": "https://www.sec.gov/news/press-release/2022-46",
                  "point": "More information"
                },
                {
                  "link": "https://www.sec.gov/rules/proposed/2022/33-11042.pdf",
                  "point": "More information"
                },
                {
                  "point": "Relevant authority:",
                  "status": "National Association of Insurance Commissioners"
                },
                {
                  "link": "https://content.naic.org/article/us-insurance-commissioners-endorse-internationally-recognized-climate-risk-disclosure-standard",
                  "point": "More information"
                },
                {
                  "link": "https://home.treasury.gov/system/files/261/FSOC-Climate-Report.pdf",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "TCFD supporters",
              "points": [
                {
                  "point": "Details",
                  "status": "Supporters are organisations that publicly and voluntarily endorse TCFD implementation."
                },
                {
                  "point": "Total number of supporters:",
                  "status": "460"
                },
                {
                  "point": "Number of financial sector supporters:",
                  "status": "262"
                },
                {
                  "link": "https://www.fsb-tcfd.org/supporters/",
                  "point": "More information"
                }
              ]
            }
          ]
        }
      ],
      "sectionTitle": "Mandatory reporting of climate-related disclosures"
    },
    "summary": {
      "content": [
        {
          "contentTitle": "UNITED KINGDOM",
          "flag": "ukFlag",
          "text": [
            {
              "header": "Regulation and supervision",
              "points": [
                {
                  "point": "Climate stress testing",
                  "status": "Completed"
                },
                {
                  "point": "Climate risk management guidelines",
                  "status": "Yes"
                },
                {
                  "point": "Green prudential policies",
                  "status": "Yes"
                },
                {
                  "point": "NGFS membership",
                  "status": "Yes"
                }
              ]
            },
            {
              "header": "Disclosures",
              "points": [
                {
                  "point": "Mandatory reporting of climate-related disclosures",
                  "status": "Yes"
                },
                {
                  "point": "Other sustainability-related disclosures",
                  "status": "Under consideration"
                }
              ]
            },
            {
              "header": "Sustainable taxonomies",
              "points": [
                {
                  "point": "Sustainable taxonomy",
                  "status": "Under development"
                }
              ]
            },
            {
              "header": "Climate action",
              "points": [
                {
                  "point": "Net zero commitment",
                  "status": "2050"
                },
                {
                  "point": "Carbon pricing",
                  "status": "Yes"
                }
              ]
            },
            {
              "header": "Nature and biodiversity",
              "points": [
                {
                  "point": "Nature-related financial policy",
                  "status": "None"
                }
              ]
            },
            {
              "header": "Fiscal policies",
              "points": [
                {
                  "point": "Taxes, tariffs and incentives",
                  "status": "Yes"
                }
              ]
            },
            {
              "header": "Capital market activity",
              "points": [
                {
                  "point": "Sovereign sustainable bonds",
                  "status": "Yes"
                },
                {
                  "point": "Green bond framework",
                  "status": "Yes"
                }
              ]
            }
          ]
        },
        {
          "contentTitle": "EUROPEAN UNION",
          "flag": "euFlag",
          "text": [
            {
              "header": "Regulation and supervision",
              "points": [
                {
                  "point": "Climate stress testing",
                  "status": "Completed"
                },
                {
                  "point": "Climate risk management guidelines",
                  "status": "Yes"
                },
                {
                  "point": "Green prudential policies",
                  "status": "Yes"
                },
                {
                  "point": "NGFS membership",
                  "status": "Yes"
                }
              ]
            },
            {
              "header": "Disclosures",
              "points": [
                {
                  "point": "Mandatory reporting of climate-related disclosures",
                  "status": "Yes"
                },
                {
                  "point": "Other sustainability-related disclosures",
                  "status": "Yes"
                }
              ]
            },
            {
              "header": "Sustainable taxonomies",
              "points": [
                {
                  "point": "Sustainable taxonomy",
                  "status": "Yes"
                }
              ]
            },
            {
              "header": "Climate action",
              "points": [
                {
                  "point": "Net zero commitment",
                  "status": "2050"
                },
                {
                  "point": "Carbon pricing",
                  "status": "Yes"
                }
              ]
            },
            {
              "header": "Nature and biodiversity",
              "points": [
                {
                  "point": "Nature-related financial policy",
                  "status": "Yes"
                }
              ]
            },
            {
              "header": "Fiscal policies",
              "points": [
                {
                  "point": "Taxes, tariffs and incentives",
                  "status": "Yes"
                }
              ]
            },
            {
              "header": "Capital market activity",
              "points": [
                {
                  "point": "Sovereign sustainable bonds",
                  "status": "Yes"
                },
                {
                  "point": "Green bond framework",
                  "status": "Yes"
                }
              ]
            }
          ]
        },
        {
          "contentTitle": "UNITED STATES",
          "flag": "usFlag",
          "text": [
            {
              "header": "Regulation and supervision",
              "points": [
                {
                  "point": "Climate stress testing",
                  "status": "In progress"
                },
                {
                  "point": "Climate risk management guidelines",
                  "status": "Yes"
                },
                {
                  "point": "Green prudential policies",
                  "status": "None"
                },
                {
                  "point": "NGFS membership",
                  "status": "Yes"
                }
              ]
            },
            {
              "header": "Disclosures",
              "points": [
                {
                  "point": "Mandatory reporting of climate-related disclosures",
                  "status": "Yes"
                },
                {
                  "point": "Other sustainability-related disclosures",
                  "status": "Under consideration"
                }
              ]
            },
            {
              "header": "Sustainable taxonomies",
              "points": [
                {
                  "point": "Sustainable taxonomy",
                  "status": "No"
                }
              ]
            },
            {
              "header": "Climate action",
              "points": [
                {
                  "point": "Net zero commitment",
                  "status": "2050"
                },
                {
                  "point": "Carbon pricing",
                  "status": "Yes"
                }
              ]
            },
            {
              "header": "Nature and biodiversity",
              "points": [
                {
                  "point": "Nature-related financial policy",
                  "status": "None"
                }
              ]
            },
            {
              "header": "Fiscal policies",
              "points": [
                {
                  "point": "Taxes, tariffs and incentives",
                  "status": "Yes"
                }
              ]
            },
            {
              "header": "Capital market activity",
              "points": [
                {
                  "point": "Sovereign sustainable bonds",
                  "status": "No"
                },
                {
                  "point": "Green bond framework",
                  "status": "No"
                }
              ]
            }
          ]
        }
      ],
      "sectionTitle": "High level summary"
    },
    "tax": {
      "content": [
        {
          "contentTitle": "UNITED KINGDOM",
          "flag": "ukFlag",
          "text": [
            {
              "header": "Tax summary",
              "points": [
                {
                  "point": "Is there a policy?",
                  "status": "Yes"
                }
              ]
            },
            {
              "header": "Subsidies for the Automotive Sector",
              "points": [
                {
                  "point": "Year implemented:",
                  "status": "2020"
                },
                {
                  "point": "Details:",
                  "status": "The automotive sector received a £73.5m investment for advanced carbon emissions cutting technologies and safeguarding 14,000 jobs. The aim of the funding is to increase the amount of low-emission cars, commercial vehicles and components."
                },
                {
                  "link": "https://www.gov.uk/government/news/735-million-to-boost-green-economic-recovery-in-automotive-sector",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "Clean growth fund",
              "points": [
                {
                  "point": "Year implemented:",
                  "status": "2020"
                },
                {
                  "point": "Details:",
                  "status": "The fund is meant for innovative green projects in energy storage, renewable heating and bioenergy technologies. In March 2022, a final fund size of £101 million was announced with the backing of 7 private sector investors alongside the Department for Business, Energy and Industrial Strategy."
                },
                {
                  "link": "https://www.gov.uk/government/publications/clean-growth-equity-fund",
                  "point": "More information"
                }
              ]
            }
          ]
        },
        {
          "contentTitle": "EUROPEAN UNION",
          "flag": "euFlag",
          "text": [
            {
              "header": "Tax summary",
              "points": [
                {
                  "point": "Is there a policy?",
                  "status": "Yes"
                }
              ]
            },
            {
              "header": "EU Energy Taxation Directive",
              "points": [
                {
                  "point": "Year implemented:",
                  "status": "2003"
                },
                {
                  "point": "Details:",
                  "status": "Establishes rules for taxation of energy products. Undergoing review to better reflect current energy mix and the EU’s climate objectives."
                },
                {
                  "link": "https://ec.europa.eu/taxation_customs/green-taxation-0_en",
                  "point": "More information"
                }
              ]
            }
          ]
        },
        {
          "contentTitle": "UNITED STATES",
          "flag": "usFlag",
          "text": [
            {
              "header": "Tax summary",
              "points": [
                {
                  "point": "Is there a policy?",
                  "status": "Yes"
                }
              ]
            },
            {
              "header": "Inflation reduction act",
              "points": [
                {
                  "point": "Year implemented:",
                  "status": "2022"
                },
                {
                  "point": "Details:",
                  "status": "On energy security, the legislation included several targeting incentives for renewables. The act extended the tax credits for renewable electricity production through 2024, with extensions also granted to clean fuels, EVs and transportation, and projects targeting clean energy use in electricity production and manufacturing."
                },
                {
                  "link": "https://www.congress.gov/bill/117th-congress/house-bill/5376/text",
                  "point": "More information"
                },
                {
                  "link": "https://www.whitehouse.gov/briefing-room/statements-releases/2022/08/04/statement-from-president-biden-on-the-inflation-reduction-act/",
                  "point": "More information"
                }
              ]
            },
            {
              "header": "Tax relief for renewable energy projects",
              "points": [
                {
                  "point": "Year implemented:",
                  "status": "2020"
                },
                {
                  "point": "Details:",
                  "status": "This provides tax relief for taxpayers that develop renewable energy projects."
                },
                {
                  "link": "https://www.iea.org/policies/11507-tax-relief-program-for-renewable-energy-projects",
                  "point": "More information"
                }
              ]
            }
          ]
        }
      ],
      "sectionTitle": "Tax, tariffs and incentives"
    },
    "taxonomies": {
      "content": [
        {
          "contentTitle": "UNITED KINGDOM",
          "flag": "ukFlag",
          "text": [
            {
              "header": "Taxonomies summary",
              "points": [
                {
                  "point": "Is there a sustainable finance taxonomy??",
                  "status": "Under consideration"
                }
              ]
            },
            {
              "header": "Green Taxonomy",
              "points": [
                {
                  "point": "Relevant authority",
                  "status": "Green Technical Advisory Group, UK Government"
                },
                {
                  "point": "Details:",
                  "status": "In June 2021, the government launched GTAG to provide independent advice on market and regulatory considerations around the taxonomy. In October 2022, GTAG published its advice on taxonomy development ahead of the Government’s first consultation on the screening criteria for two of the six environmental objectives within the taxonomy. Whilst it has been expected that much of the taxonomy would take the shape of EU regulation, GTAG has recommended an ‘adopt some and revise some’ approach whereby a small number of technical criteria are amended to meet UK-specific targets and frameworks, and noted that the UK Government has the option to adopt the EU screening criteria in the short term."
                },
                {
                  "link": "https://assets.publishing.service.gov.uk/government/uploads/system/uploads/attachment_data/file/1031805/CCS0821102722-006_Green_Finance_Paper_2021_v6_Web_Accessible.pdf",
                  "point": "More information"
                },
                {
                  "link": "https://www.greenfinanceinstitute.co.uk/wp-content/uploads/2022/10/GTAG-Advice-on-the-development-of-a-UK-Green-Taxonomy.pdf",
                  "point": "More information"
                }
              ]
            }
          ]
        },
        {
          "contentTitle": "EUROPEAN UNION",
          "flag": "euFlag",
          "text": [
            {
              "header": "Taxonomies summary",
              "points": [
                {
                  "point": "Is there a sustainable finance taxonomy??",
                  "status": "Yes"
                }
              ]
            },
            {
              "header": "EU Sustainable Finance Taxonomy",
              "points": [
                {
                  "point": "Relevant authority",
                  "status": "European Commission"
                },
                {
                  "point": "Details:",
                  "status": "The EU taxonomy – a classification system for sustainable economic assets and investments – provides appropriation categorisations and definitions for policymakers, investors and companies to combat greenwashing and encourage investment.The 2020 EU Taxonomy Regulation set out four overarching conditions that economic activities have to meet to qualify as environmentally sustainable. These must contribute substantially to one or more of the objectives while not significantly harming any other objectives, meeting minimum social safeguards and complying with six technical screening criteria. In December 2021, Delegated Acts on disclosures and climate were passed. In July 2022, the Complementary Climate Delegated Act introduced additional energy sector activities into the taxonomy, including transitional classifications for nuclear and gas activities, applicable from the start of 2023.In June 2022, the International Platform on Sustainable Finance published an updated instruction report on the Common Ground Taxonomy, observing commonalities between the EU and Chinese green classification regimes."
                },
                {
                  "link": "https://ec.europa.eu/info/business-economy-euro/banking-and-finance/sustainable-finance/eu-taxonomy-sustainable-activities_en#what",
                  "point": "More information"
                },
                {
                  "link": "https://ec.europa.eu/info/sites/default/files/business_economy_euro/banking_and_finance/documents/200309-sustainable-finance-teg-final-report-taxonomy_en.pdf",
                  "point": "More information"
                }
              ]
            }
          ]
        },
        {
          "contentTitle": "UNITED STATES",
          "flag": "usFlag",
          "text": [
            {
              "header": "Taxonomies summary",
              "points": [
                {
                  "point": "Is there a sustainable finance taxonomy?",
                  "status": "None"
                }
              ]
            }
          ]
        }
      ],
      "sectionTitle": "Sustainable taxonomies"
    }
  }

  return <AccordionItem>
      <h2>
        <AccordionButton>
          <Box as="span" flex='1' textAlign='left'>
            <Heading size="xs" color="esg_gray.200">
              {extendedJson[title].sectionTitle}
            </Heading>
          </Box>
          <AccordionIcon/>
        </AccordionButton>
      </h2>
      <AccordionPanel pb={4}>
        <Grid templateColumns="repeat(3, 1fr)" templateRows="repeat(1, 1fr)" gap={5}>
          <GridItem>
            <SustainableFinanceRegulationsBox
              text={extendedJson[title].content[0].text}
              flag={extendedJson[title].content[0].flag}
              contentTitle={extendedJson[title].content[0].contentTitle} />
          </GridItem>
          <GridItem>
          <SustainableFinanceRegulationsBox
              text={extendedJson[title].content[1].text}
              flag={extendedJson[title].content[1].flag}
              contentTitle={extendedJson[title].content[1].contentTitle} />
        </GridItem>
          <GridItem>
          <SustainableFinanceRegulationsBox
              text={extendedJson[title].content[2].text}
              flag={extendedJson[title].content[2].flag}
              contentTitle={extendedJson[title].content[2].contentTitle} />
          </GridItem>
        </Grid>
      </AccordionPanel>
  </AccordionItem>
}

export default SustainableFinanceRegulationsAccordionItem;